<template>
  <asc-page-header class="asc-mx-rec-header-wrapper">
    <template #pageTitle>
      <asc-page-title :title="getTitle"></asc-page-title>
    </template>
    <template #pageActions>
      <asc-sticky
        v-if="
          !isReadOnlyPermissionInvestigate ||
          isCustomAlert ||
          isChronicRepeaters
        "
        class="asc-mx-rec-header-wrapper__sticky"
        :class="{ isSticky: isSticky }"
        :is-sticky="isSticky"
        :offset-top="0"
      >
        <v-row no-gutters>
          <v-col>
            <div class="d-flex justify-end">
              <asc-accent-button
                v-if="!disableSave"
                outline
                secondary
                :on-click="handleCancel"
                button-text="Cancel"
              ></asc-accent-button>
              <asc-accent-button
                class="ml-4"
                :button-text="getButtonText"
                :on-click="handleSave"
                :loading="saveLoading"
                :disabled="handleSaveDisable"
              ></asc-accent-button>
            </div>
          </v-col>
        </v-row>
      </asc-sticky>
    </template>
  </asc-page-header>
</template>

<script>
import AscAccentButton from '../../components/atoms/AscAccentButton'
import AscPageHeader from '@/components/atoms/AscPageHeader'
import AscPageTitle from '@/components/atoms/AscPageTitle'
import AscSticky from '@/components/atoms/AscSticky'

import {
  AscMxRecPropsMixin,
  AscMxRecPermissionMixin,
} from '@/components/mixins'

export default {
  name: 'AscMxRecHeaderWrapper',

  components: {
    AscPageHeader,
    AscPageTitle,
    AscAccentButton,
    AscSticky,
  },

  mixins: [AscMxRecPropsMixin, AscMxRecPermissionMixin],

  props: {
    issueId: {
      type: Number,
      required: true,
    },
    tabIndex: {
      type: Number,
      default: 0,
    },
    disableSave: {
      type: Boolean,
      default: false,
    },
    saveLoading: {
      type: Boolean,
      default: false,
    },
    isSticky: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      step1To:
        'https://collins-ds-reports.azurewebsites.net/Reporting/html/index.html',
    }
  },

  computed: {
    getTitle() {
      return `Issue ${this.issueId}`
    },

    getButtonText() {
      return 'Save'
    },

    handleSaveDisable() {
      return this.disableSave
    },
  },

  methods: {
    handleCancel() {
      this.$emit('onCancel')
    },

    handleSave() {
      this.$emit('onSave', 'save')
    },
  },
}
</script>

<style lang="scss">
.asc-mx-rec-header-wrapper {
  margin: 0;

  &__sticky {
    .isSticky {
      padding: 6px 26px !important;
    }
  }
}
</style>
